import React, { useState, useEffect } from 'react';
import { graphql, Link } from 'gatsby';
import Seo from '../components/seo';
import NewLayout from '../components/new_layout';
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';
import CustomerLogos from '../components/v2023/CustomerLogos/customer-logos';
import ReadyToTalk from '../components/v2023/ReadyToTalk/ready-to-talk';
import MainSection100 from '../components/Layout/main-section-100';
import { Container } from '../components/Layout/containers';
import ReactMarkdown from 'react-markdown';
import LinkButton from '../components/v2023/UI/LinkButton/link-button';
import rehypeRaw from 'rehype-raw';
import { Tile } from '../components/v2024/tile/tile';
import { SquareTabs } from '../components/v2026/square-tabs';

const IndexPage = ({ data, pageContext }) => {
	const lang = pageContext.langKey;
	const page = data.page.nodes[0];
	const sectors = [...new Set(page.our_customers_say.map((customer) => customer.sector))];
	const [activeSector, setActiveSector] = useState(sectors[0]);

	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const checkViewport = () => setIsMobile(window.innerWidth < 992);
		checkViewport();
		window.addEventListener('resize', checkViewport);
		return () => window.removeEventListener('resize', checkViewport);
	}, []);

	return (
		<NewLayout pageContext={pageContext}>
			<Seo
				lang={lang}
				title={page.seo.title}
				description={page.seo.meta_description}
				translates={pageContext.translates}
				image={page.seo?.image_2?.localFile?.publicURL}
			/>

			<main className="main main--index">
				{/* Banner de novedades */}
				{/* {showAlert && (
					<div className="banner">
						<div className="banner__body">
							<i className="icon-star"></i>
							<strong>{page.novedades.text}</strong>
							{page.novedades.button_blank ? (
								<a
									href={page.novedades.button_url}
									className="button button--secondary button--secondary--ghost button--sm"
									target="_blank"
									rel="noreferrer"
								>
									{page.novedades.button_text} <i className="icon-arrow-right"></i>
								</a>
							) : (
								<Link
									to={page.novedades.button_url}
									className="button button--secondary button--secondary--ghost button--sm"
								>
									{page.novedades.button_text} <i className="icon-arrow-right"></i>
								</Link>
							)}
						</div>
						<div className="banner__action">
							<button className="button-icon" onClick={() => setShowAlert(!showAlert)}>
								<i className="icon-close"></i>
							</button>
						</div>
					</div>
				)} */}

				<MainSection100 sectionType="white" sectionColor="white" noContainer>
					<Container animation="fade-up" slim>
						<h1 className="hero">{page.titulo}</h1>
						<div className="container__text">
							<ReactMarkdown children={page.descripcion} rehypePlugins={[rehypeRaw]} />
						</div>
						{page.contactar && <LinkButton button={page.contactar} className="button button--xl" />}
						{page.animacion_principal?.localFile?.publicURL && (
							// <Player src={page.animacion_principal.localFile.publicURL} autoplay loop />
							<div className="video" data-aos="fade-up">
								{!isMobile && (
									<video autoplay muted loop className="hidden-md">
										<source src={page.animacion_principal.localFile.publicURL} type="video/mp4" />
									</video>
								)}
								<div className="show-md hidden-sm">
									<GatsbyImage
										alt={
											page.animacion_principal_tablet.name ||
											page.animacion_principal_tablet.title
										}
										image={getImage(page.animacion_principal_tablet.localFile)}
									/>
								</div>
								<div className="show-sm">
									<GatsbyImage
										alt={
											page.animacion_principal_mobile.name ||
											page.animacion_principal_mobile.title
										}
										image={getImage(page.animacion_principal_mobile.localFile)}
									/>
								</div>
							</div>
						)}
					</Container>
				</MainSection100>

				<CustomerLogos lang={lang} />

				<MainSection100 sectionType="white">
					<div className="grid grid-lg-2-3">
						{page.productos.map((producto) => (
							<a
								key={producto.id}
								className={`card card--highlight card--highlight--${producto.product_color}`}
								href={producto.link}
							>
								<div className="card__body">
									{producto.icon?.localFile && (
										<div className="card__body__image">
											<GatsbyImage
												alt={producto.icon.name || producto.title}
												image={getImage(producto.icon.localFile)}
											/>
										</div>
									)}
									<div className="card__body__description">
										<h4>{producto.title}</h4>
										<ReactMarkdown
											children={producto.description}
											rehypePlugins={[rehypeRaw]}
										/>
									</div>
									<span className="see-more">
										{producto.link_text} <i className="icon-arrow-right" />
										<Link to={producto.link}></Link>
									</span>
								</div>
							</a>
						))}
					</div>
				</MainSection100>

				<MainSection100 sectionColor="purple-dark" sectionType="color" noFrame noContainer>
					<Container>
						{page.proceso_onboarding_titulo && <h2>{page.proceso_onboarding_titulo}</h2>}

						<SquareTabs sectionColor="purple-dark" tabs={page.proceso_onboarding} />
					</Container>

					<Container>
						{page.solicita_demo && (
							<div data-aos="fade-up">
								<Tile
									title={page.solicita_demo.titulo}
									body={page.solicita_demo.descripcion}
									button={page.solicita_demo.boton}
								/>
							</div>
						)}
					</Container>
					<Container>
						<h2>{page.our_customers_say_title}</h2>

						{/* Tabs para filtrar por sector */}
						<div className="tabs tabs--pills tabs--pills-big tabs--pills-big--ghost ">
							{sectors.map((sector, index) => (
								<div
									key={index}
									className={`tabs__tab ${activeSector === sector ? 'tabs__tab--active' : ''}`}
								>
									<button onClick={() => setActiveSector(sector)}>{sector}</button>
								</div>
							))}
						</div>

						{/* Mostrar sólo los customer_say del sector activo */}
						<div className="customer-say-items">
							{page.our_customers_say
								.filter((customer) => customer.sector === activeSector)
								.map((customer, index) => (
									<div key={index} className="tile tile--kpi">
										<div className="tile__body">
											<div className="tile__body__image">
												<div className="image__logo">
													<GatsbyImage
														alt={customer.logo.name || customer.logo.title}
														image={getImage(customer.logo.localFile)}
													/>
												</div>
												<div className="image__kpi">
													<div className="title-xl">{customer.percentage}</div>
													<span>{customer.percentage_text}</span>
												</div>
											</div>
											<div className="tile__body__info">
												<h4>{customer.title}</h4>
												<ReactMarkdown
													children={customer.description}
													rehypePlugins={[rehypeRaw]}
												/>
												<Link className="link--big" to={customer.url}>
													{customer.show_more}
													<i className="icon-arrow-right"></i>
												</Link>
											</div>
										</div>
									</div>
								))}
						</div>
						{/* <div className="container__margin-negative"></div> */}
					</Container>
				</MainSection100>

				{page.compliance && (
					<MainSection100>
						<ReactMarkdown children={page.compliance.title} rehypePlugins={[rehypeRaw]} />
						<div className="container__text">
							<ReactMarkdown children={page.compliance.description} rehypePlugins={[rehypeRaw]} />
						</div>
						{page.compliance.button && (
							<LinkButton button={page.compliance.button} className="button button--xl" />
						)}
					</MainSection100>
				)}

				<MainSection100 noContainer>
					<Container np>
						<div className="grid-md">
							<StaticImage
								src={'../new/resources/compliance/9001.png'}
								alt="9001"
								placeholder="blurred"
								style={{ display: lang === 'es' ? 'block' : 'none' }}
							/>
							<StaticImage
								src={'../new/resources/compliance/9001_EN.png'}
								alt="9001"
								placeholder="blurred"
								style={{ display: lang === 'es' ? 'none' : 'block' }}
							/>
							<StaticImage
								src={'../new/resources/compliance/iqnet.png'}
								alt="IQnet"
								placeholder="blurred"
							/>
							<StaticImage
								src={'../new/resources/compliance/fido.png'}
								alt="Fido"
								placeholder="blurred"
							/>
							<StaticImage
								src={'../new/resources/compliance/eidas.png'}
								alt="Eidas"
								placeholder="blurred"
								style={{ display: lang === 'es' ? 'block' : 'none' }}
							/>
							<StaticImage
								src={'../new/resources/compliance/eidas_EN.png'}
								alt="Eidas"
								placeholder="blurred"
								style={{ display: lang === 'es' ? 'none' : 'block' }}
							/>
							<StaticImage
								src={'../new/resources/compliance/aml6.png'}
								alt="AML6"
								placeholder="blurred"
							/>
							<StaticImage src={'../new/resources/compliance/sca.png'} alt="SCA" placeholder="blurred" />
							<StaticImage
								src={'../new/resources/compliance/27701.png'}
								alt="27701"
								placeholder="blurred"
								style={{ display: lang === 'es' ? 'block' : 'none' }}
							/>
							<StaticImage
								src={'../new/resources/compliance/27703_EN.png'}
								alt="27701"
								placeholder="blurred"
								style={{ display: lang === 'es' ? 'none' : 'block' }}
							/>
							<StaticImage
								src={'../new/resources/compliance/gdpr.png'}
								alt="GDPR"
								placeholder="blurred"
							/>
						</div>
					</Container>
				</MainSection100>

				<MainSection100>
					<div className="ready-to-talk-simple">
						<ReadyToTalk lang={lang} hideTags />
					</div>
				</MainSection100>
			</main>
		</NewLayout>
	);
};

export default IndexPage;

export const indexPageQuery = graphql`
	query ($langKey: String) {
		page: allStrapi2025Home(filter: { locale: { eq: $langKey } }) {
			nodes {
				id
				titulo
				descripcion
				locale
				published_at
				proceso_onboarding_titulo
				seo {
					id
					title
					meta_description
					image_2 {
						localFile {
							publicURL
							childImageSharp {
								gatsbyImageData(width: 1200, placeholder: BLURRED, formats: [WEBP, PNG])
							}
						}
					}
				}
				contactar {
					id
					text
					url
					blank
				}
				productos {
					id
					title
					description
					link_text
					link
					product_color
					icon {
						id
						name
						localFile {
							publicURL
							childImageSharp {
								gatsbyImageData(width: 64, placeholder: BLURRED, formats: [WEBP, PNG])
							}
						}
					}
				}
				proceso_onboarding {
					proceso_onboarding_name
                	proceso_onboarding_icon
					proceso_onboarding_item {
						id
						titulo
						descripcion
						porcentaje
						texto_porcentaje
						url_text
						url_porcentaje
						imagen {
							localFile {
								publicURL
							}
						}
					}
				}
				solicita_demo {
					id
					titulo
					descripcion
					boton {
						id
						text
						url
						blank
					}
				}
				our_customers_say_title
				our_customers_say {
					sector
					logo {
						id
						name
						localFile {
							publicURL
							childImageSharp {
								gatsbyImageData(width: 230, placeholder: BLURRED, formats: [WEBP, PNG])
							}
						}
					}
					percentage
					percentage_text
					title
					description
					show_more
					url
				}
				compliance {
					id
					title
					description
					button {
						id
						text
						url
						blank
					}
				}
				animacion_principal {
					name
					localFile {
						publicURL
						childImageSharp {
							gatsbyImageData(
								breakpoints: [928, 704, 636, 520, 512, 350],
								width: 1200, 
								placeholder: BLURRED, 
								formats: [WEBP, PNG],
								sizes: "(max-width: 768px) 50vw, 1200px",
                                outputPixelDensities: [1]
							)
						}
					}
				}
				animacion_principal_tablet {
					name
					localFile {
						publicURL
						childImageSharp {
							gatsbyImageData(
								breakpoints: [928, 704, 636, 520, 512, 350],
								width: 928, 
								placeholder: BLURRED, 
								formats: [WEBP, PNG],
								sizes: "(max-width: 768px) 50vw, 928px",
                                outputPixelDensities: [1]
							)
						}
					}
				}
				animacion_principal_mobile {
					id
					name
					localFile {
						publicURL
						childImageSharp {
							gatsbyImageData(
								breakpoints: [636, 520, 512, 350]
								width: 703, 
								placeholder: BLURRED, 
								formats: [WEBP, PNG],
								sizes: "(max-width: 768px) 50vw, 703px",
                                outputPixelDensities: [1]
							)
						}
					}
				}
			}
		}

		industries: allStrapiIndustry(filter: { locale: { eq: $langKey }, show_in_home: { eq: true } }) {
			edges {
				node {
					name
					tag
					url
					orderId
					icon_new {
						name
						alternativeText
						localFile {
							publicURL
						}
					}
					industries_category {
						id
						url
						title
					}
				}
			}
		}
		sectors: allStrapiSector(filter: { locale: { eq: $langKey }, show_home: { eq: true } }) {
			edges {
				node {
					url
					tag
					icon {
						name
						alternativeText
						localFile {
							childImageSharp {
								gatsbyImageData(width: 48, placeholder: BLURRED, formats: [WEBP], breakpoints: [27])
							}
						}
					}
				}
			}
		}

		caseStudies: allStrapiCaseStudy(
			filter: { locale: { eq: $langKey } }
			sort: { fields: id, order: DESC }
			limit: 4
		) {
			edges {
				node {
					id
					title
					tag
					url
					logo_new {
						alternativeText
						localFile {
							childImageSharp {
								gatsbyImageData(width: 600, placeholder: BLURRED, formats: [WEBP, PNG])
							}
						}
					}
				}
			}
		}
	}
`;
